import { Box, useTheme } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
// import { tokens } from "../../theme";
import Header from "../../components/Header";
import GlobalLiveSearch from "../../sections/GlobalLiveSearch/GlobalLiveSearch";

const GlobalSearch = () => {
    const theme = useTheme();
    // const colors = tokens(theme.palette.mode);

    // const isDesktop = useResponsive("up", "md");
    const isMobile = useResponsive("between", "md", "xs", "sm");

    return (
        <Box
            ml= {isMobile ? "0px" : "20px"}
            mr= {isMobile ? "0px" : "20px"}
        >
            {/* HEADER */}
            {!isMobile &&
                <Box display="flex" justifyContent="space-between" alignItems="center" height={'100px'}>
                    <Header title="Search" subtitle="Global search." />
                </Box>
            }
            {/* CONTEXT */}
            <GlobalLiveSearch 
                sx={{
                    height: "100%",
                    width: "100%",
                    minWidth: "320px",
                    backgroundColor:
                        theme.palette.mode === "light"
                            ? "#F8FAFF"
                            : theme.palette.background,
                    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                }}
            />
        </Box>
    )
};

export default GlobalSearch;